let intervalId: NodeJS.Timeout;

const DETECTION_KEY = '__anti_debug_detection_count__';

function getDetectionCount(): number {
    return parseInt(localStorage.getItem(DETECTION_KEY) || '0', 10);
}

function setDetectionCount(count: number): void {
    localStorage.setItem(DETECTION_KEY, count.toString());
}

function resetDetectionCount(): void {
    localStorage.removeItem(DETECTION_KEY);
}

function isConsoleOpen(): boolean {
    const start = performance.now();
    Function('debugger')();
    const end = performance.now();
    return end - start > 100;
}

function infiniteLoop(): void {
    const rand = () => Math.random();
    while (rand() !== -1) {
        console.log('⚠️ Infinite loop running...');
    }
}

function crashWithWorker(): void {
    const blob = new Blob(
        ["onmessage=function(){while(true){}}"],
        { type: "application/javascript" }
    );
    const url = URL.createObjectURL(blob);
    const worker = new Worker(url);
    worker.postMessage('');
}

function escalateResponse(useWorker = false): void {
    const current = getDetectionCount();
    const next = current + 1;
    setDetectionCount(next);

    switch (next) {
        case 1:
            console.warn('🕵️ DevTools detected. Please close it.');
            break;

        case 2:
            alert("DevTools is not allowed here. Behavior is being monitored.");
            break;

        default:
            console.error('🔥 Repeated DevTools use detected. Enforcing protection...');
            if (useWorker) {
                crashWithWorker();
            } else {
                setTimeout(infiniteLoop, 100);
            }
            break;
    }
}

export function startAntiDebug({ useWorker = false }: { useWorker?: boolean } = {}): void {
    if (process.env.NODE_ENV !== 'production') return;

    intervalId = setInterval(() => {
        if (isConsoleOpen()) {
            escalateResponse(useWorker);
        }
    }, 3000);
}

export function stopAntiDebug(): void {
    clearInterval(intervalId);
}

export function clearAntiDebugHistory(): void {
    resetDetectionCount();
}